import useSelectableReferences from "../../ReferencesHooks/useSelectableReferences";
import ReferencesList from "./ReferencesList";

const NewReferences = ({
  createdRecords,
  modulesMap,
  field,
  selected,
  setSelected,
  setKeepOpen,
  setHideReference,
  oneTap,
  onClose,
}) => {
  const { isRecordSelected, handleSelectRecord } = useSelectableReferences({
    field,
    selected,
    setSelected,
    oneTap,
    onClose,
  });

  if (!createdRecords?.length) return null;

  return (
    <>
      <h5 className="px-3">Recently Created</h5>
      <div className="px-2 border-bottom pb-2 mb-2">
        <ReferencesList
          records={createdRecords}
          modulesMap={modulesMap}
          isRecordSelected={isRecordSelected}
          handleSelectRecord={handleSelectRecord}
          handleOpen={handleOpen}
          handleClose={handleClose}
          setKeepOpen={setKeepOpen}
        />
      </div>
    </>
  );

  function handleOpen() {
    setKeepOpen(true);
    setHideReference(true);
  }

  function handleClose() {
    setKeepOpen(false);
    setHideReference(false);
  }
};

export default NewReferences;
